var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { all, call, cancelled, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { E_CORE_ACTION_TYPES } from './actionTypes';
import { coreServices } from 'src/services/core/coreServices';
import { coreActions } from './coreActions';
import { getFileUrls, getLocale, getNotifications, getRealm, getUrlConfigs } from './coreSelectors';
import { casesActions } from '../cases/casesActions';
import { buildCandidateLocales, FALLBACK_LOCALE, getValidI18nPayload } from './helpers/localeHelpers';
import { setDefaultDateLocale } from 'src/shared/helpers/dateHelpers';
import { checkLocaleQueryInUrl, parseApiPingResponse, parseCasesDefaultColumn, parseDefaultCasesFilters, parseDefaultUsersFilters, parseFilters, } from './helpers/parsers';
import { base64ToObj, convertMixKeyMapAndObjToObj, deepMergeObj, getPropsByKeyPath, valueExist, } from 'src/shared/helpers/objHelpers';
import { usersActions } from 'src/redux/users/usersActions';
import { E_HOST, queriesParamsToObj } from 'src/shared/helpers/urlHelpers';
import { getNow } from 'src/shared/helpers/dateHelpers';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
import { E_REQUEST_METHOD, ServiceHelpers } from 'src/services/ServicesHelpers';
import { filesParser } from 'src/redux/cases/helpers/filesParser';
import { sagasCreator } from 'src/redux/helpers/sagasCreators';
import { E_SNACKBAR_TYPE } from 'src/ui/components/SnackBar/SnackBar';
import { API_NAME } from 'src/services/constants';
import { enhanceDynamicData } from 'src/redux/core/helpers/dynamicData';
import { replaceVariablesInString } from 'src/shared/helpers/stringHelpers';
import { getLocalStorage } from 'src/shared/helpers/storageHelpers';
import { IMAGES_TO_CACHE, SOUNDS, windowExist } from 'src/shared/constants';
import { E_FILE_TYPE } from 'src/redux/core/types';
import { FileUrlsHelpers } from 'src/redux/core/helpers/fileUrlsHelpers';
import { mergeMoConfigs } from './helpers/moConfigHelpers';
// Usefull to keep in cache all sounds even if we loose network connection
function preLoadSound() {
    var basePath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                basePath = windowExist ? window.env.BASE_PATH : '';
                return [4 /*yield*/, Object.values(SOUNDS).map(function (file) {
                        var audio = new Audio();
                        audio.src = "".concat(basePath).concat(file);
                        return audio;
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function preLoadImages() {
    var basePath;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                basePath = windowExist ? window.env.BASE_PATH : '';
                return [4 /*yield*/, Object.values(IMAGES_TO_CACHE).map(function (file) {
                        var image = new Image();
                        image.src = "".concat(basePath).concat(file);
                        return image;
                    })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function updateConf(action) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, put(casesActions.resetCases())];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(coreActions.resetConf())];
            case 2:
                _a.sent();
                return [4 /*yield*/, put(coreActions.updateUrlConfSucceeded(action.urlConfigs))];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function fetchMoConfig() {
    var systemConfClient, systemConfResp, realm, orgConfClient, orgConfResp, systemConf, orgConf;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(function () { return coreServices.fetchMoConfigSystem(); })];
            case 1:
                systemConfClient = _a.sent();
                return [4 /*yield*/, systemConfClient.callAPI()];
            case 2:
                systemConfResp = _a.sent();
                if (systemConfResp.error) {
                    console.log('Error trying to fetch MO system configuration: ', systemConfResp.errorMessage);
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, select(getRealm)];
            case 3:
                realm = _a.sent();
                return [4 /*yield*/, call(function () { return coreServices.fetchMoConfig(realm); })];
            case 4:
                orgConfClient = _a.sent();
                return [4 /*yield*/, orgConfClient.callAPI()];
            case 5:
                orgConfResp = _a.sent();
                if (orgConfResp.error) {
                    console.log('Error trying to fetch MO organization configuration: ', orgConfResp.errorMessage);
                    return [2 /*return*/, null];
                }
                systemConf = systemConfResp.payload;
                orgConf = orgConfResp.payload;
                return [2 /*return*/, mergeMoConfigs(systemConf, orgConf)];
        }
    });
}
export function fetchStaticI18n(candidateLocales) {
    var _loop_1, _i, candidateLocales_1, locale, state_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _loop_1 = function (locale) {
                    var client, response, payload;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, call(function () { return coreServices.fetchI18NDefaultLocale(locale); })];
                            case 1:
                                client = _b.sent();
                                return [4 /*yield*/, client.callAPI()];
                            case 2:
                                response = _b.sent();
                                payload = getValidI18nPayload(response);
                                if (payload) {
                                    return [2 /*return*/, { value: { locale: locale, payload: payload } }];
                                }
                                console.log("No valid static i18n file for locale \"".concat(locale, "\""));
                                return [2 /*return*/];
                        }
                    });
                };
                _i = 0, candidateLocales_1 = candidateLocales;
                _a.label = 1;
            case 1:
                if (!(_i < candidateLocales_1.length)) return [3 /*break*/, 4];
                locale = candidateLocales_1[_i];
                return [5 /*yield**/, _loop_1(locale)];
            case 2:
                state_1 = _a.sent();
                if (typeof state_1 === "object")
                    return [2 /*return*/, state_1.value];
                _a.label = 3;
            case 3:
                _i++;
                return [3 /*break*/, 1];
            case 4: return [2 /*return*/, { locale: FALLBACK_LOCALE, payload: null }];
        }
    });
}
export function applyLocale(locale) {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, call(setDefaultDateLocale, locale)];
            case 1:
                _a.sent();
                return [4 /*yield*/, put(coreActions.updateLocale(locale))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function fetchI18n(defaultLocale) {
    var urlConfig, isQPC, realm, userLocale, candidateLocales, _a, locale, staticI18n, i18nSystemResponse, i18nRealmResponse, i18nKYCResponse, resultSystem, resultRealm, validStaticPayload, validSystemPayload, validRealmPayload, i18nMerged, resultKYC, validKYCPayload, KYCTranslation, i18nToFullyObjStruct;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getUrlConfigs)];
            case 1:
                urlConfig = _b.sent();
                isQPC = (urlConfig === null || urlConfig === void 0 ? void 0 : urlConfig.host) === E_HOST.QPC;
                return [4 /*yield*/, select(getRealm)];
            case 2:
                realm = _b.sent();
                return [4 /*yield*/, select(getLocale)];
            case 3:
                userLocale = _b.sent();
                candidateLocales = buildCandidateLocales(userLocale, defaultLocale);
                return [4 /*yield*/, call(fetchStaticI18n, candidateLocales)];
            case 4:
                _a = _b.sent(), locale = _a.locale, staticI18n = _a.payload;
                return [4 /*yield*/, call(applyLocale, locale)];
            case 5:
                _b.sent();
                return [4 /*yield*/, call(function () { return coreServices.fetchI18NSystem(locale); })];
            case 6:
                i18nSystemResponse = _b.sent();
                return [4 /*yield*/, call(function () { return coreServices.fetchI18NRealm(realm, locale); })];
            case 7:
                i18nRealmResponse = _b.sent();
                return [4 /*yield*/, call(function () { return coreServices.fetchI18NKYC(realm, locale); })];
            case 8:
                i18nKYCResponse = _b.sent();
                return [4 /*yield*/, i18nSystemResponse.callAPI()];
            case 9:
                resultSystem = _b.sent();
                if (resultSystem.error) {
                    console.log('Error during fetching i18n from systems : ', resultSystem.errorMessage);
                }
                return [4 /*yield*/, i18nRealmResponse.callAPI()];
            case 10:
                resultRealm = _b.sent();
                if (resultRealm.error) {
                    console.log('Error during fetching i18n from realm : ', resultRealm.errorMessage);
                }
                validStaticPayload = staticI18n ? convertMixKeyMapAndObjToObj(staticI18n) : {};
                validSystemPayload = getValidI18nPayload(resultSystem);
                validRealmPayload = getValidI18nPayload(resultRealm);
                i18nMerged = deepMergeObj(deepMergeObj(validStaticPayload, validSystemPayload ? convertMixKeyMapAndObjToObj(validSystemPayload) : {}), validRealmPayload ? convertMixKeyMapAndObjToObj(validRealmPayload) : {});
                if (!isQPC) return [3 /*break*/, 12];
                return [4 /*yield*/, i18nKYCResponse.callAPI()];
            case 11:
                resultKYC = _b.sent();
                if (resultKYC.error) {
                    console.log('Error during fetching i18n from kyc : ', resultKYC.errorMessage);
                }
                validKYCPayload = getValidI18nPayload(resultKYC);
                if (validKYCPayload) {
                    KYCTranslation = {
                        kyc: convertMixKeyMapAndObjToObj(validKYCPayload),
                    };
                    i18nMerged = deepMergeObj(i18nMerged, KYCTranslation);
                }
                _b.label = 12;
            case 12:
                i18nToFullyObjStruct = convertMixKeyMapAndObjToObj(i18nMerged);
                return [2 /*return*/, i18nToFullyObjStruct];
        }
    });
}
function fetchDynamicData(dataFetchingConf) {
    var dynamicDataKeyConfig, realm, data, _i, dynamicDataKeyConfig_1, _a, key, config, _b, apiName, apiPath, restConfig, basePath, path, _c, callAPI, abort, _d, status_1, payload, error, errorMessage, headers, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0:
                if (!dataFetchingConf) {
                    return [2 /*return*/, {}];
                }
                return [4 /*yield*/, Object.entries(dataFetchingConf)];
            case 1:
                dynamicDataKeyConfig = _g.sent();
                return [4 /*yield*/, select(getRealm)];
            case 2:
                realm = _g.sent();
                return [4 /*yield*/, {}];
            case 3:
                data = _g.sent();
                _i = 0, dynamicDataKeyConfig_1 = dynamicDataKeyConfig;
                _g.label = 4;
            case 4:
                if (!(_i < dynamicDataKeyConfig_1.length)) return [3 /*break*/, 10];
                _a = dynamicDataKeyConfig_1[_i], key = _a[0], config = _a[1];
                _b = config, apiName = _b.apiName, apiPath = _b.apiPath, restConfig = __rest(_b, ["apiName", "apiPath"]);
                basePath = window.env[API_NAME[apiName]];
                path = replaceVariablesInString("".concat(basePath).concat(apiPath), { realm: realm });
                return [4 /*yield*/, serviceCreator(E_REQUEST_METHOD.GET, path, true, {
                        enableDefaultEvents: true,
                    })];
            case 5:
                _c = _g.sent(), callAPI = _c.callAPI, abort = _c.abort;
                return [4 /*yield*/, callAPI()];
            case 6:
                _d = _g.sent(), status_1 = _d.status, payload = _d.payload, error = _d.error, errorMessage = _d.errorMessage, headers = _d.headers;
                if (!(!error && payload)) return [3 /*break*/, 8];
                _e = data;
                _f = key;
                return [4 /*yield*/, enhanceDynamicData(restConfig, payload)];
            case 7:
                _e[_f] = _g.sent();
                return [3 /*break*/, 9];
            case 8:
                data[key] = [];
                _g.label = 9;
            case 9:
                _i++;
                return [3 /*break*/, 4];
            case 10: return [2 /*return*/, data];
        }
    });
}
function fetchConfig() {
    var moConfig, configs, isAtLeastOneConfigError, i18n, allQueries, defaultCasesFilter, allCasesColumnParsed, defaultCasesColumnVisible_1, defaultUsersFilter, allUsersColumnParsed, usersColumnVisible, queries, filtersQuery, localStorage_1, localColumns, localColumnsUpdated, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 22, , 23]);
                return [4 /*yield*/, call(preLoadSound)];
            case 1:
                _a.sent();
                return [4 /*yield*/, call(preLoadImages)];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(fetchMoConfig)];
            case 3:
                moConfig = _a.sent();
                return [4 /*yield*/, all({
                        i18n: call(fetchI18n, moConfig === null || moConfig === void 0 ? void 0 : moConfig.defaultLocale),
                        dynamics: fetchDynamicData(moConfig === null || moConfig === void 0 ? void 0 : moConfig.externalDataFetching),
                    })];
            case 4:
                configs = _a.sent();
                isAtLeastOneConfigError = Object.values(configs).some(function (config) { return config === null; });
                if (!isAtLeastOneConfigError) return [3 /*break*/, 6];
                i18n = configs.i18n;
                return [4 /*yield*/, put(coreActions.addNotificationRequested({
                        type: E_SNACKBAR_TYPE.ERROR,
                        description: i18n ? getPropsByKeyPath(i18n.modules, 'fetchUtil.errorFetch') : "Can't fetch i18n config at least",
                    }))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                allQueries = parseFilters(moConfig.search.filters, moConfig.search.filterPresets, configs.i18n, configs.dynamics);
                defaultCasesFilter = parseDefaultCasesFilters(configs.i18n, moConfig.search.defaultQuery, allQueries);
                allCasesColumnParsed = parseCasesDefaultColumn(moConfig.search.columns, configs.i18n);
                defaultCasesColumnVisible_1 = allCasesColumnParsed.filter(function (col) { return col.display; });
                defaultUsersFilter = parseDefaultUsersFilters(configs.i18n, moConfig.userManagement.defaultQuery);
                allUsersColumnParsed = parseCasesDefaultColumn(moConfig.userManagement.columns, configs.i18n);
                usersColumnVisible = allUsersColumnParsed.filter(function (col) { return col.display; });
                return [4 /*yield*/, put(casesActions.saveAllQueries(allQueries))
                    // if already have filter query in url we don't set default filter
                ];
            case 7:
                _a.sent();
                queries = queriesParamsToObj(window.location.search);
                if (!(Object.keys(queries).length < 1)) return [3 /*break*/, 9];
                return [4 /*yield*/, put(casesActions.updateSearchFilterSucceeded(defaultCasesFilter))];
            case 8:
                _a.sent();
                return [3 /*break*/, 13];
            case 9:
                filtersQuery = base64ToObj(queries.filter);
                if (!filtersQuery) return [3 /*break*/, 11];
                return [4 /*yield*/, put(casesActions.updateSearchFilterSucceeded(checkLocaleQueryInUrl(filtersQuery, allQueries)))];
            case 10:
                _a.sent();
                return [3 /*break*/, 13];
            case 11: return [4 /*yield*/, put(casesActions.updateSearchFilterSucceeded(defaultCasesFilter))];
            case 12:
                _a.sent();
                _a.label = 13;
            case 13: return [4 /*yield*/, put(casesActions.setDefaultFilter(defaultCasesFilter))];
            case 14:
                _a.sent();
                localStorage_1 = getLocalStorage();
                localColumns = localStorage_1 === null || localStorage_1 === void 0 ? void 0 : localStorage_1.columns;
                localColumnsUpdated = localColumns
                    ? localColumns.reduce(function (acc, localColumn) {
                        var defaultConfColumn = defaultCasesColumnVisible_1.find(function (column) { return column.label === localColumn.label; });
                        return __spreadArray(__spreadArray([], acc, true), [
                            __assign(__assign({}, localColumn), defaultConfColumn),
                        ], false);
                    }, [])
                    : null;
                return [4 /*yield*/, put(casesActions.saveAllColumns(allCasesColumnParsed))];
            case 15:
                _a.sent();
                return [4 /*yield*/, put(casesActions.updateDefaultColumnRequested(defaultCasesColumnVisible_1))];
            case 16:
                _a.sent();
                return [4 /*yield*/, put(casesActions.updateColumnRequested(localColumnsUpdated || defaultCasesColumnVisible_1))];
            case 17:
                _a.sent();
                return [4 /*yield*/, put(usersActions.updateUsersFilterSucceeded(defaultUsersFilter))];
            case 18:
                _a.sent();
                return [4 /*yield*/, put(usersActions.saveAllColumns(allUsersColumnParsed))];
            case 19:
                _a.sent();
                return [4 /*yield*/, put(usersActions.updateColumn(usersColumnVisible))];
            case 20:
                _a.sent();
                return [4 /*yield*/, put(coreActions.fetchConfSucceeded(__assign(__assign({}, configs), moConfig)))];
            case 21:
                _a.sent();
                return [3 /*break*/, 23];
            case 22:
                err_1 = _a.sent();
                console.log("Can't fetch config :", err_1);
                return [3 /*break*/, 23];
            case 23: return [2 /*return*/];
        }
    });
}
function addNotification(action) {
    var notification, notifications, notificationEnhanced;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                notification = action.notification;
                return [4 /*yield*/, select(getNotifications)];
            case 1:
                notifications = _a.sent();
                notificationEnhanced = __assign(__assign({}, notification), { id: getNow().toMillis() });
                return [4 /*yield*/, put(coreActions.addNotificationSucceeded(__spreadArray(__spreadArray([], notifications, true), [notificationEnhanced], false)))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function removeNotification(action) {
    var notification, notifications, notificationsFiltered;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                notification = action.notification;
                return [4 /*yield*/, select(getNotifications)];
            case 1:
                notifications = _a.sent();
                notificationsFiltered = notifications.filter(function (notif) { return notif.id !== notification.id; });
                return [4 /*yield*/, put(coreActions.removeNotificationSucceeded(notificationsFiltered))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
/*
  Each time we want to fetch files, we trigger addFileUrls with the fileUrls to add as a parameter
  addFileUrls will manage both the fetched fileUrls and those about to be added
  It will filter fetched fileUrls in order to avoid fetching again those
*/
function addFileUrls(action) {
    var _a, filesUrls, _b, toParse, filesUrlsState, fileUrlsNeedToBeFetch, filesUrlsKey, fileUrlsByPriority, _i, fileUrlsByPriority_1, filesUrlpriority, filesUrlsFetched, filesUrlsFetchedReformat, filesUrlsStateInCancel_1, filesUrlNotFetched_1, filesNotLoaded, fileToError;
    var _this = this;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, action];
            case 1:
                _a = _c.sent(), filesUrls = _a.filesUrls, _b = _a.toParse, toParse = _b === void 0 ? false : _b;
                return [4 /*yield*/, select(getFileUrls)];
            case 2:
                filesUrlsState = _c.sent();
                fileUrlsNeedToBeFetch = FileUrlsHelpers.retrieveFileNotFetchingYet(filesUrlsState, filesUrls);
                filesUrlsKey = Object.entries(fileUrlsNeedToBeFetch).map(function (_a) {
                    var key = _a[0];
                    return key;
                });
                // Stop here if no fileUrlToFetch
                if (filesUrlsKey.length < 1) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(coreActions.addFilesUrlsSucceeded(fileUrlsNeedToBeFetch))];
            case 3:
                _c.sent();
                fileUrlsByPriority = FileUrlsHelpers.splitFilesUrlsByPriority(fileUrlsNeedToBeFetch);
                _c.label = 4;
            case 4:
                _c.trys.push([4, , 11, 17]);
                _i = 0, fileUrlsByPriority_1 = fileUrlsByPriority;
                _c.label = 5;
            case 5:
                if (!(_i < fileUrlsByPriority_1.length)) return [3 /*break*/, 10];
                filesUrlpriority = fileUrlsByPriority_1[_i];
                return [4 /*yield*/, all(filesUrlpriority.map(function (fileUrl) { return __awaiter(_this, void 0, void 0, function () {
                        var _a, callAPI, abort, _b, status, payload, error, errorMessage, headers, type, mimeType;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _a = serviceCreator(E_REQUEST_METHOD.GET, fileUrl.key, true, {
                                        parser: toParse ? filesParser : null,
                                        params: { responseType: 'arraybuffer' },
                                    }), callAPI = _a.callAPI, abort = _a.abort;
                                    return [4 /*yield*/, callAPI()
                                        // We could receive an arrayBuffer or a base64 string due to filesParser
                                        // if payload is array each item is of the same type
                                    ];
                                case 1:
                                    _b = _c.sent(), status = _b.status, payload = _b.payload, error = _b.error, errorMessage = _b.errorMessage, headers = _b.headers;
                                    type = FileUrlsHelpers.getFileUrlType(payload);
                                    mimeType = FileUrlsHelpers.getFileUrlMimeType(payload);
                                    return [2 /*return*/, __assign(__assign({}, fileUrl), { headers: headers || null, file: payload || null, isError: !!error, isLoading: false, fileUpdated: type === E_FILE_TYPE.IMAGE ? payload : null, 
                                            // time spent on video could be there
                                            type: type, mimeType: mimeType })];
                            }
                        });
                    }); }))
                    // As yield all() require array of functions, we must pass key into data during fetching API,
                    // after that we go back from array to obj and restore key as properties of this obj to match with IFilesUrl structure
                ];
            case 6:
                filesUrlsFetched = _c.sent();
                return [4 /*yield*/, filesUrlsFetched.reduce(function (acc, curr) {
                        var _a;
                        var key = curr.key, rest = __rest(curr, ["key"]);
                        return __assign(__assign({}, acc), (_a = {}, _a[key] = __assign({}, rest), _a));
                    }, {})];
            case 7:
                filesUrlsFetchedReformat = _c.sent();
                return [4 /*yield*/, put(coreActions.addFilesUrlsSucceeded(filesUrlsFetchedReformat))];
            case 8:
                _c.sent();
                _c.label = 9;
            case 9:
                _i++;
                return [3 /*break*/, 5];
            case 10: return [3 /*break*/, 17];
            case 11: return [4 /*yield*/, cancelled()];
            case 12:
                if (!_c.sent()) return [3 /*break*/, 16];
                return [4 /*yield*/, select(getFileUrls)
                    // filter fileUrls that are not fetched in state
                ];
            case 13:
                filesUrlsStateInCancel_1 = _c.sent();
                filesUrlNotFetched_1 = Object.entries(fileUrlsNeedToBeFetch).reduce(function (acc, _a) {
                    var _b;
                    var key = _a[0], fileUrl = _a[1];
                    var fileUrlState = filesUrlsStateInCancel_1[key];
                    if (fileUrlState.file || fileUrlState.isError) {
                        return acc;
                    }
                    else {
                        return __assign(__assign({}, acc), (_b = {}, _b[key] = fileUrl, _b));
                    }
                }, {});
                return [4 /*yield*/, all(Object.keys(ServiceHelpers.callOnProcess).map(function (key) {
                        return ServiceHelpers.callOnProcess[key] ? ServiceHelpers.callOnProcess[key].abort() : null;
                    }))];
            case 14:
                _c.sent();
                filesNotLoaded = Object.entries(filesUrlsStateInCancel_1).reduce(function (acc, _a) {
                    var _b;
                    var key = _a[0], fileUrl = _a[1];
                    var fileUrlNotFetched = filesUrlNotFetched_1[key];
                    if (fileUrlNotFetched) {
                        return __assign(__assign({}, acc), (_b = {}, _b[key] = __assign(__assign({}, fileUrlNotFetched), { isLoading: false, isError: true }), _b));
                    }
                    else {
                        return acc;
                    }
                }, {});
                fileToError = __assign(__assign({}, filesUrlsStateInCancel_1), filesNotLoaded);
                return [4 /*yield*/, put(coreActions.addFilesUrlsSucceeded(fileToError))];
            case 15:
                _c.sent();
                _c.label = 16;
            case 16: return [7 /*endfinally*/];
            case 17: return [2 /*return*/];
        }
    });
}
function pingApi() {
    var realm, callAPICases, callAPIIAM, callAPIConfigs, callAPISearch, callAPIKeycloak, callAPISSE, apis, _a, _b, _c, _d, _e, _f, _g, _h;
    return __generator(this, function (_j) {
        switch (_j.label) {
            case 0: return [4 /*yield*/, select(getRealm)];
            case 1:
                realm = _j.sent();
                return [4 /*yield*/, call(function () { return coreServices.pingCases(); })];
            case 2:
                callAPICases = (_j.sent()).callAPI;
                return [4 /*yield*/, call(function () { return coreServices.pingIAM(); })];
            case 3:
                callAPIIAM = (_j.sent()).callAPI;
                return [4 /*yield*/, call(function () { return coreServices.pingConfigs(); })];
            case 4:
                callAPIConfigs = (_j.sent()).callAPI;
                return [4 /*yield*/, call(function () { return coreServices.pingSearch(); })];
            case 5:
                callAPISearch = (_j.sent()).callAPI;
                return [4 /*yield*/, call(function () { return coreServices.pingKeycloak(realm); })];
            case 6:
                callAPIKeycloak = (_j.sent()).callAPI;
                return [4 /*yield*/, call(function () { return coreServices.pingSSE(); })];
            case 7:
                callAPISSE = (_j.sent()).callAPI;
                _a = all;
                _b = {};
                _c = parseApiPingResponse;
                return [4 /*yield*/, callAPICases()];
            case 8:
                _b.cases = _c.apply(void 0, [_j.sent(), 'Case API']);
                _d = parseApiPingResponse;
                return [4 /*yield*/, callAPIIAM()];
            case 9:
                _b.iam = _d.apply(void 0, [_j.sent(), 'Iam API']);
                _e = parseApiPingResponse;
                return [4 /*yield*/, callAPIConfigs()];
            case 10:
                _b.config = _e.apply(void 0, [_j.sent(), 'Config API']);
                _f = parseApiPingResponse;
                return [4 /*yield*/, callAPISearch()];
            case 11:
                _b.search = _f.apply(void 0, [_j.sent(), 'Search API']);
                _g = parseApiPingResponse;
                return [4 /*yield*/, callAPISSE()];
            case 12:
                _b.sse = _g.apply(void 0, [_j.sent(), 'SSE']);
                _h = parseApiPingResponse;
                return [4 /*yield*/, callAPIKeycloak()];
            case 13: return [4 /*yield*/, _a.apply(void 0, [(_b.keycloak = _h.apply(void 0, [_j.sent(), 'Keycloak']),
                        _b)])];
            case 14:
                apis = _j.sent();
                return [4 /*yield*/, put(coreActions.pingApiSucceeded(apis))];
            case 15:
                _j.sent();
                return [2 /*return*/];
        }
    });
}
// Update file like image without update base file
// 2 cases:
// - update all sources
// - update only one source with sourceIndex
function updateFileUrlSource(action) {
    var url, sources, sourceIndex, fileUrls, fileTargeted, isAllSources, sourcesUpdated, fileUrlsUpdated;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                url = action.url, sources = action.sources, sourceIndex = action.sourceIndex;
                return [4 /*yield*/, select(getFileUrls)];
            case 1:
                fileUrls = _b.sent();
                fileTargeted = fileUrls[url];
                isAllSources = Array.isArray(sources);
                if (!!!fileTargeted) return [3 /*break*/, 3];
                sourcesUpdated = isAllSources
                    ? sources
                    : valueExist(sourceIndex)
                        ? fileTargeted.fileUpdated.map(function (file, index) {
                            if (index === sourceIndex) {
                                return sources;
                            }
                            return file;
                        })
                        : fileTargeted.fileUpdated;
                fileUrlsUpdated = __assign(__assign({}, fileUrls), (_a = {}, _a[url] = __assign(__assign({}, fileUrls[url]), { fileUpdated: sourcesUpdated }), _a));
                return [4 /*yield*/, put(coreActions.addFilesUrlsSucceeded(fileUrlsUpdated))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
export function coreSagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(E_CORE_ACTION_TYPES.UPDATE_URL_CONF_REQUESTED, updateConf)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CORE_ACTION_TYPES.FETCH_CONF_REQUESTED, fetchConfig)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CORE_ACTION_TYPES.ADD_NOTIFICATION_REQUESTED, addNotification)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CORE_ACTION_TYPES.REMOVE_NOTIFICATION_REQUESTED, removeNotification)];
            case 4:
                _a.sent();
                return [4 /*yield*/, sagasCreator(E_CORE_ACTION_TYPES.ADD_FILE_URLS_REQUESTED, E_CORE_ACTION_TYPES.ADD_FILE_URLS_CANCELLED, addFileUrls)];
            case 5:
                _a.sent();
                return [4 /*yield*/, takeLatest(E_CORE_ACTION_TYPES.PING_API_REQUESTED, pingApi)];
            case 6:
                _a.sent();
                return [4 /*yield*/, takeEvery(E_CORE_ACTION_TYPES.UPDATE_FILE_URL_SOURCE, updateFileUrlSource)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
